import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import lodash from "lodash";
import { Notification } from "@/types";
import { maskname } from '@/utils/app-util';
import { getNotificationList } from '@/api/notificationService';
import { getMeasurementTypes } from '@/api/patientsService';
import { patientRecordsModule } from "@/store/modules/patientRecords";

export interface NotificationState {
  notifications: Notification[];
  loading: boolean;
}

@Module({ store, dynamic: true, name: "notificationModule" })
class NotificationModule extends VuexModule implements NotificationState {
  public notifications: Notification[] = [];
  public loading = false;


  @Action async getNotificationList() {
    this.setLoading(true);
    const re = /^[0-9][a-zA-Z]/;
    patientRecordsModule.setMeasurementTypes(await getMeasurementTypes());
    const data = await getNotificationList();
    data.sort((a,b)=>b.created_at - a.created_at);
    data.forEach(element => {
      const date = new Date(
        element.created_at * 1000
      ).toLocaleString();
      element.created_at = date;
      element.payload.user['realName'] = element.payload.user.name;
      if(element.payload.user.name.substring(0,2)==='民眾'){
        element.payload.user.name = element.payload.user.name.substring(0,3) + maskname(element.payload.user.name.substring(3));
      }
      else if(element.payload.user.name.substring(0,2)==='院內'){
        element.payload.user.name = element.payload.user.name.substring(0,5) + maskname(element.payload.user.name.substring(5));
      }
      else if(!re.test(element.payload.user.name)||element.payload.user.name.length >= 10){
        element.payload.user.name = maskname(element.payload.user.name)
      }
      if(element.payload.data === "blood_pressure")
      {
        element.payload.data = "血壓";
      }
      else if(element.payload.data === "spo2")
      {
        element.payload.data = "血氧量測";
      }
      else
      {
        element.payload.data = patientRecordsModule.measurementTypes[element.payload.data].i18n.zh;
      }
    });
    
    //console.log(data);
    this.setNotifications(data);
    this.setLoading(false);
  }

  @Mutation setLoading(loading: boolean): void {
    this.loading = loading;
  }

  @Mutation setNotifications(notifications: Notification[]): void {
    this.notifications = lodash.cloneDeep(notifications);
  }
}

export const notificationModule = getModule(NotificationModule);
